import { render, staticRenderFns } from "./SmsView.vue?vue&type=template&id=f6c62d74"
import script from "./SmsView.vue?vue&type=script&lang=js"
export * from "./SmsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports